"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.createI18nInstance = void 0;

var _i18next = _interopRequireDefault(require("i18next"));

var _reactI18next = require("react-i18next");

var _i18nextBrowserLanguagedetector = _interopRequireDefault(require("i18next-browser-languagedetector"));

var _i18nextXhrBackend = _interopRequireDefault(require("i18next-xhr-backend"));

var _detector = require("./detector.options");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    });
    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(source, true).forEach(function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(source).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

var createI18nInstance = function createI18nInstance(i18nOptions) {
  var i18n = _i18next.default.createInstance();

  i18n.use(_i18nextXhrBackend.default).use(_i18nextBrowserLanguagedetector.default).use(_reactI18next.initReactI18next).init(_objectSpread({
    debug: false,
    detector: _detector.detectorOptions,
    interpolation: {
      escapeValue: false
    },
    // use keys as fallback
    fallbackLng: false,
    backend: {
      // eslint-disable-next-line no-undef
      loadPath: "".concat(process.env.PUBLIC_URL, "/locales/{{lng}}.json")
    }
  }, i18nOptions));
  return i18n;
};

exports.createI18nInstance = createI18nInstance;
var _default = createI18nInstance;
exports.default = _default;